import React from 'react';
import './Footer.css'

const Footer = () => {
    return (
        <div className='footer'>
            <footer>
                <div className='footer__links--half'>
                    <ul className='footer__links'>
                        <li className='footer__link'>Help</li>
                        <li className='footer__link'>Send Feedback</li>
                        <li className='footer__link'>Privacy</li>
                        <li className='footer__link'>Terms</li>
                    </ul>
                </div>
            </footer>
            
        </div>
    );
}

export default Footer;
